import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  contentChild,
  input,
  output,
  TemplateRef,
} from '@angular/core';

import { ButtonModule } from '@plugins/client/button/legacy-button';
import { ColorsModule } from '@plugins/client/colors/colors.module';
import { CancelIconComponent } from '@plugins/client/icons/cancel-icon';
import { ExclamationIconComponent } from '@plugins/client/icons/exclamation-icon';
import { TranslatePipe } from '@plugins/client/translate/pipes';

import { NoticeTranslationModule } from '../translation-loader';

export type NoticeType = 'toast' | 'toast-float' | 'inlined' | 'actionable';

@Component({
  selector: 'plugins-notice',
  imports: [
    CommonModule,
    NoticeTranslationModule,
    TranslatePipe,
    ButtonModule,
    CancelIconComponent,
    ExclamationIconComponent,
    ColorsModule,
  ],
  templateUrl: './notice.component.html',
  styleUrl: './notice.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoticeComponent {
  readonly type = input<NoticeType>('inlined');
  readonly color = input<string>();
  readonly dismissLabel = input<string>();

  readonly dismiss = output<void>();
  readonly iconTemplateRef = contentChild<TemplateRef<unknown>>('iconTemplate');

  readonly actionTemplateRef =
    contentChild<TemplateRef<unknown>>('actionTemplate');
}
